import { render } from "./VIpsum.vue?vue&type=template&id=5bbf3f76"
import script from "./VIpsum.vue?vue&type=script&lang=js"
export * from "./VIpsum.vue?vue&type=script&lang=js"

import "./VIpsum.vue?vue&type=style&index=0&id=5bbf3f76&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__